var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5818 9.39546C20.4322 9.51155 17.7904 11.0001 17.7904 14.3101C17.7904 18.1386 21.152 19.493 21.2526 19.5265C21.2371 19.6091 20.7186 21.3815 19.4802 23.1873C18.376 24.7765 17.2229 26.3631 15.4686 26.3631C13.7143 26.3631 13.2628 25.3441 11.2376 25.3441C9.264 25.3441 8.56229 26.3967 6.95762 26.3967C5.35295 26.3967 4.23329 24.9262 2.94595 23.1203C1.45479 20.9996 0.25 17.7052 0.25 14.5784C0.25 9.56315 3.51093 6.90332 6.72027 6.90332C8.42555 6.90332 9.84705 8.02298 10.9177 8.02298C11.9367 8.02298 13.5259 6.83624 15.466 6.83624C16.2012 6.83624 18.843 6.90332 20.5818 9.39546ZM14.545 4.71302C15.3473 3.76106 15.9149 2.44017 15.9149 1.11929C15.9149 0.936119 15.8994 0.75037 15.8658 0.600739C14.5604 0.649756 13.0074 1.47015 12.0709 2.55627C11.3356 3.39214 10.6494 4.71302 10.6494 6.05197C10.6494 6.2532 10.6829 6.45442 10.6984 6.51892C10.781 6.5344 10.9151 6.55246 11.0493 6.55246C12.2205 6.55246 13.6936 5.76818 14.545 4.71302Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 25.7985,
    fill: "white",
    transform: "translate(0.25 0.600739)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.6b9409ec4937ddf8e7c56ff179df4f99.svg";
export { ForwardRef as ReactComponent };